import { useEffect, useState } from "react";
import type { ILocationMapConfig } from "../customTypings/location/Location";
import { locationsService } from "../services/locations/locations.service";
import { getUserFacingErrorMessage, logErrorForDev } from "../utils";

let cachedConfig: ILocationMapConfig | null = null;
let inflight: Promise<ILocationMapConfig> | null = null;

export function useGoogleMapsConfig() {
    const [config, setConfig] = useState<ILocationMapConfig | null>(cachedConfig);
    const [loading, setLoading] = useState(!cachedConfig);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (cachedConfig) {
            setConfig(cachedConfig);
            setLoading(false);
            return;
        }

        if (!inflight) {
            inflight = locationsService.getMapConfig().then((result) => {
                cachedConfig = result;
                return result;
            });
        }

        inflight
            .then((result) => {
                setConfig(result);
                setError(null);
            })
            .catch((e: unknown) => {
                logErrorForDev("useGoogleMapsConfig.load", e);
                setError(getUserFacingErrorMessage(e, "Could not load map configuration."));
            })
            .finally(() => setLoading(false));
    }, []);

    return { config, loading, error };
}
